import { OPERATIONAL_QUEUE } from 'modules/arena/dashboard/content';
import { Card } from 'shared/components/ui/Card';
import { useToast } from 'shared/components/ui/Toast';

export function OperationalQueue() {
  const toast = useToast();

  return (
    <Card>
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-ink">Fila operacional</h3>
        <button type="button" className="text-xs font-medium text-primary hover:underline"
          onClick={() =>
            toast({
              tone: 'info',
              title: 'Fila operacional completa',
              description: 'Em breve: histórico de eventos com filtros por tipo e período.',
            })
          }>
          Ver tudo
        </button>
      </div>

      <ul className="mt-3 divide-y divide-border/70">
        {OPERATIONAL_QUEUE.map((item) => (
          <li key={item.title} className="py-2 text-sm">
            <p className="text-ink">{item.title}</p>
            <p className="text-xs text-ink-secondary">{item.meta}</p>
          </li>
        ))}
      </ul>
    </Card>
  );
}
